import { render, staticRenderFns } from "./light-gallery.vue?vue&type=template&id=c37c6e04&scoped=true&"
import script from "./light-gallery.vue?vue&type=script&lang=js&"
export * from "./light-gallery.vue?vue&type=script&lang=js&"
import style0 from "./light-gallery.vue?vue&type=style&index=0&id=c37c6e04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37c6e04",
  null
  
)

export default component.exports